module.exports = __webpack_public_path__ + "img/16l006-14.0fd6fab5.jpg";